/* eslint-disable camelcase */
import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

import { formatNumberToUnit } from '../../../utils/formatNumbers';

import IconLoadPeakShaving from '../../../assets/icon-load-peak-shaving.svg';
import TableDefault from '../../common/TableDefault';

const Root = styled.div`
	h3 {
		margin-bottom: 40px;
		font-size: 20px;
		font-weight: bold;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
	}

	img {
		width: 100px;
		margin: 0 10%;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	.modal-content {
		display: flex;
		max-width: 700px;
		margin: 0 auto;
	}

	.modal-table {
		margin-top: 40px;
	}
`;

const headers = [
	{
		name: '',
		prop: 'a',
	},
	{
		name: 'Energieverbrauch',
		prop: 'b',
	},
	{
		name: 'max. Peak',
		prop: 'c',
	},
	{
		name: 'Vollbenutzungsstunden',
		prop: 'd',
	},
	{
		name: 'Netzentgelte',
		prop: 'e',
	},
];

const Analyseauswertung = ({ data }) => {
	const { without_battery, with_battery } = data.kpis;

	const parsedTableData = [
		{
			a: 'Ohne Batterie',
			b: formatNumberToUnit(without_battery.energy_consumption, ' GWh'),
			c: formatNumberToUnit(without_battery.peak, ' kW'),
			d: formatNumberToUnit(without_battery.flh, ' h'),
			e: formatNumberToUnit(without_battery.gridTariffs, ' €'),
		},
		{
			a: 'Mit Batterie',
			b: formatNumberToUnit(with_battery.energy_consumption, ' GWh'),
			c: formatNumberToUnit(with_battery.peak, ' kW'),
			d: formatNumberToUnit(with_battery.flh, ' h'),
			e: formatNumberToUnit(with_battery.gridTariffs, ' €'),
		},
	];

	return (
		<Root>
			<Typography variant="h3">Ihre Analyseauswertung</Typography>
			<div className="modal-content">
				<img src={IconLoadPeakShaving} alt="Netzentgelt" />
				<div className="modal-text">
					<Typography variant="h6">Lastspitzenkappung</Typography>
					<Typography>
						Um eine Reduktion der Netzentgelte für Sie zu erreichen, setzen
						wir eine Kombination aus intelligenter Software und neueste
						Batteriespeichertechnologie ein.
					</Typography>
					<Typography>
						Sobald die Lastspitzen gekappt werden, übernimmt der
						Batteriespeicher und versorgt Sie zuverlässig mit der benötigten
						Energie.
					</Typography>
					<Typography>
						Bei der Auswertung Ihres Lastgangs haben wir ermittelt, dass Sie
						durch Kappen der Lastpitzen Ihre Netzgebühren signifikant
						reduzieren können:
					</Typography>
				</div>
			</div>
			<div className="modal-table">
				<TableDefault data={parsedTableData} header={headers} size="small" />
			</div>
		</Root>
	);
};

export default Analyseauswertung;
